import { Navigate, Outlet } from "react-router-dom";

import { useMe } from "@/hooks/useMe";
import { isMaitimeStaff } from "@/lib/nav-config";

/**
 * Shell del backoffice Maitime.
 *
 * Non ha più né sidebar né header propri: la navigazione del backoffice è
 * entrata nella barra laterale del portale (voce «Admin», che si apre sulle sue
 * 16 pagine), e salute + notifiche sono salite nell'header globale, dove seguono
 * lo staff anche fuori da `/admin`. Restava altrimenti una seconda colonna di
 * navigazione affiancata alla prima.
 *
 * Qui resta il gating MAITIME_STAFF, centralizzato (prima era ripetuto in ogni
 * pagina admin) e comunque difeso lato API.
 */
export function AdminLayout() {
  const { data: me, isLoading } = useMe();

  if (isLoading) return null;
  if (me && !isMaitimeStaff(me)) return <Navigate to="/" replace />;

  return (
    <main className="px-6 py-6">
      <Outlet />
    </main>
  );
}
